export const FETCH_LICENSE = 'FETCH_LICENSE' as const;
export const FETCH_LICENSE_SUCCESS = 'FETCH_LICENSE_SUCCESS' as const;
export const FETCH_LICENSE_FAIL = 'FETCH_LICENSE_FAIL' as const;
export const FETCH_LICENSE_CANCEL = 'FETCH_LICENSE_CANCEL' as const;

export const SAVE_LICENSE = 'SAVE_LICENSE' as const;
export const SAVE_LICENSE_SUCCESS = 'SAVE_LICENSE_SUCCESS' as const;
export const SAVE_LICENSE_FAIL = 'SAVE_LICENSE_FAIL' as const;
export const SAVE_LICENSE_CANCEL = 'SAVE_LICENSE_CANCEL' as const;

export const CREATE_LICENSE = 'CREATE_LICENSE' as const;
export const CREATE_LICENSE_SUCCESS = 'CREATE_LICENSE_SUCCESS' as const;
export const CREATE_LICENSE_FAIL = 'CREATE_LICENSE_FAIL' as const;
export const CREATE_LICENSE_CANCEL = 'CREATE_LICENSE_CANCEL' as const;
